import { Component, Input, OnInit } from '@angular/core';
import { Charge } from '../models/charge.models';
import { CommonModule } from "@angular/common";
import { CurrencyClpPipe } from "../pipes/currency-clp.pipe";
import { DocTypeLabelPipe } from '../pipes/doc-type.pipe';
import { MerchantService } from '../../../services/merchant.service';

@Component({
  selector: 'app-voucher-template',
  standalone: true,
  imports: [CommonModule, CurrencyClpPipe, DocTypeLabelPipe],
  templateUrl: './voucher-template.component.html'
})
export class VoucherTemplateComponent implements OnInit {
    @Input({ required: true }) charge!: Charge;

    merchantName: string;
    merchantIdentification: string;
    merchantAddress: string;

    fechaSolicitud = (() => {
        const fecha = new Intl.DateTimeFormat('es-CL', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }).format(new Date());
        return fecha.charAt(0).toUpperCase() + fecha.slice(1);
    })

    constructor(
        private merchantService: MerchantService
    ) {}

    async ngOnInit(): Promise<void> {
        this.merchantIdentification = localStorage.getItem('merchant_identification_number');
        this.merchantAddress = localStorage.getItem('merchant_address');
        this.merchantName = localStorage.getItem('merchant_name') || '';
    }

    getMerchantAddress(): string {
        const { address, city, state } = this.merchantService.getMerchantAddress();
        return `${address}, ${city}, ${state}`
    }
}